import { render, staticRenderFns } from "./ModuleLoader.vue?vue&type=template&id=1d556613&"
import script from "./ModuleLoader.vue?vue&type=script&lang=js&"
export * from "./ModuleLoader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleLoader.vue?vue&type=style&index=0&id=1d556613&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d556613')) {
      api.createRecord('1d556613', component.options)
    } else {
      api.reload('1d556613', component.options)
    }
    module.hot.accept("./ModuleLoader.vue?vue&type=template&id=1d556613&", function () {
      api.rerender('1d556613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/ModuleLoader.vue"
export default component.exports